module.exports = __webpack_public_path__ + "media/กล้าขัดคำสั่งผมเหรอ.c4da79c6.mp3";